import { PiShoppingCart, PiUser } from "react-icons/pi";
import LinkLanguage from "locales/LinkLanguage";
import { Badge, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { useEffectDeviceAndOrientation } from "utils/hooks";
import { isLogin } from "services/LocalStorage/LocalStorage.service";

import "./HeaderIcons.scss";
import LanguageSelector from "locales/LanguageSelector";
import ThemeSwitcher from "theme/ThemeSwitcher";
import { IoHeartOutline } from "react-icons/io5";

const HeaderIcons = () => {
  const cart = useSelector((store: any) => store.cart);
  const [device, orientation] = useEffectDeviceAndOrientation();
  const size = device === "mobile" ? "10%" : "10%";

  return (
    <>
      {/* KORISNIK */}
      {device === "computer" && orientation === "landscape" && (
        <>
          {/* PROFIL KORISNIKA */}
          {isLogin() && (
            <LinkLanguage className="Header-Icon" to="/profile">
              <Tooltip title="Profil">
                <PiUser className="custom-icon" />
              </Tooltip>
            </LinkLanguage>
          )}
          {/* LOGIN KORISNIKA */}
          {isLogin() === false && (
            <LinkLanguage className="Header-Icon" to="/login">
              <Tooltip title="Prijavi se">
                <PiUser className="custom-icon" />
              </Tooltip>
            </LinkLanguage>
          )}

          <ThemeSwitcher />
        </>
      )}
      {/* OMILJENI PROIZVODI */}
      <LinkLanguage
        to="/profile/favorite"
        className="Header-Icon"
        // title={`Vidi detaljno`}
      >
        <Tooltip title="Omiljeni artikli">
          <IoHeartOutline className="custom-icon" />
        </Tooltip>
      </LinkLanguage>

      {/* KORPA */}
      <LinkLanguage to="/cart" className="Header-Icon">
        <Badge
          count={cart.total_count ? cart.total_count : 0}
          className="Header-Badge"
        >
          <Tooltip title="Korpa">
            <PiShoppingCart className="custom-icon" />
          </Tooltip>
        </Badge>
      </LinkLanguage>

      {/* TODO PROMENA JEZIKA */}
      {/* <LanguageSelector /> */}
    </>
  );
};
export default HeaderIcons;
